import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output
} from '@angular/core';
import { CommonModule } from '@angular/common';

export interface DropdownItem {
  label: string;
  url?: string;
  action?: () => void;
  disabled?: boolean;
}

@Component({
  selector: 'app-resource-dropdown',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './resource-dropdown.component.html',
  styleUrls: ['./resource-dropdown.component.scss']
})
export class ResourceDropdownComponent {
  @Input() items: DropdownItem[] = [];
  @Input() buttonText = 'Menu';
  @Input() disabled = false;

  @Output() itemClick = new EventEmitter<DropdownItem>();
  @Output() menuToggle = new EventEmitter<boolean>();

  isOpen = false;

  toggle() {
    if (this.disabled) return;
    this.isOpen = !this.isOpen;
    this.menuToggle.emit(this.isOpen);
  }

  close() {
    this.isOpen = false;
    this.menuToggle.emit(false);
  }

  onItemClick(item: DropdownItem) {
    if (item.disabled) return;

    this.itemClick.emit(item);
    if (item.action && !item.url) {
      item.action();
    }
    this.close();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    const container = target.closest('.dropdown-container');

    if (!container) {
      this.close();
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey() {
    this.close();
  }
}
